"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventViewModel = void 0;
const FlowNodeViewModel_1 = require("../FlowNodeViewModel");
class EventViewModel extends FlowNodeViewModel_1.FlowNodeViewModel {
    constructor(event, processModel) {
        var _a, _b, _c, _d;
        super(event, processModel);
        this.messageName = (_a = event.messageEventDefinition) === null || _a === void 0 ? void 0 : _a.name;
        this.messageId = (_b = event.messageEventDefinition) === null || _b === void 0 ? void 0 : _b.id;
        this.signalName = (_c = event.signalEventDefinition) === null || _c === void 0 ? void 0 : _c.name;
        this.signalId = (_d = event.signalEventDefinition) === null || _d === void 0 ? void 0 : _d.id;
    }
}
exports.EventViewModel = EventViewModel;
//# sourceMappingURL=EventBaseViewModel.js.map